import { makeEntityScaffold } from '@classpass/saga-tools';
import urls from 'constants/urls';
import { transformKeysToCamelCase } from 'helpers/core';

const handler = ({ httpClient }, { payoutId, venueId }) => {
  const endpoint = urls.reports.payoutDetails({ payoutId, venueId });
  return httpClient.get(endpoint, { ignoreInternalError: true }).then(({ data }) => transformKeysToCamelCase(data));
};

export default makeEntityScaffold('SAGA.API.PAYOUT_DETAILS', handler);
